import {createSlice, isAnyOf} from '@reduxjs/toolkit';
import {loadAppData, refreshAppData} from './actions';
import {getInitialState} from './initialState';

const initialState = getInitialState();

const slice = createSlice({
  name: 'ui/calendar',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadAppData.pending, (state) => {
        state.isLoading = true;
        state.loadingState = 'Loading';
        state.timestamp = new Date().toISOString();
      })
      .addCase(refreshAppData.pending, (state) => {
        state.isRefreshing = true;
        state.loadingState = 'Loading';
        state.timestamp = new Date().toISOString();
      })
      .addMatcher(isAnyOf(loadAppData.fulfilled, loadAppData.rejected), (state) => {
        state.isLoading = false;
        state.loadingState = 'Loaded';
      })
      .addMatcher(isAnyOf(refreshAppData.fulfilled, refreshAppData.rejected), (state) => {
        state.isRefreshing = false;
        state.loadingState = 'Failed';
      });
  },
});

export const {reducer: uiCalendarReducer} = slice;
